<template>
  <div class="glz animation srcospcur">
    <div v-if="list.length>0" v-html="list[0].content"></div>
  </div>
</template>
<script>
export default {
  props: {
    data: [Object, Array]
  },
  data() {
    return {
      list: this.$props.data
    };
  }
};
</script>